
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_1lpjm_97",
  "slider-side": "awsui_slider-side_cqzlk_1lpjm_132",
  "slider-icon": "awsui_slider-icon_cqzlk_1lpjm_139",
  "slider-icon-bottom": "awsui_slider-icon-bottom_cqzlk_1lpjm_145",
  "slider-icon-side": "awsui_slider-icon-side_cqzlk_1lpjm_149"
};
  